import { useMutation } from "react-query";

import { useNotify } from "~/shared/hooks/useNotify";

import { useIvideon } from "./useIvideon";

export const useGetIvideonReport = (closeModal: () => void) => {
  const { getIvideonReport } = useIvideon();
  const { notifyReport } = useNotify();
  const { data, isLoading, isError, mutate } = useMutation({
    mutationFn: (sort: string) => getIvideonReport(sort),

    onSuccess: (response) => {
      const hash = response?.data?.fileHash;
      if (hash) {
        notifyReport(hash);

        closeModal();
      }
    },
  });

  return {
    data: data?.data,
    isLoading: isLoading,
    isError: isError,
    getIvideonDataReport: mutate,
  };
};
